@if (loading()) {
  <app-cab-loading height="600px" />
} @else {
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="mx-auto w-100">
    <div class="modal-body">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-4">
          <app-cab-input
            [controlName]="form.get('name')"
            label="COMPANY.MODAL.INPUT_MODAL_TEXT"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-4">
          <app-cab-autocomplete
            [_defaultService]="_regionService"
            [firstLoad]="true"
            label="GEOGRAPHY.DISTRICTS.TABLE_HEADERS.REGION"
            [controlName]="form.get('regionId')"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-4">
          <app-cab-autocomplete
            [firstLoad]="true"
            [_defaultService]="_districtService"
            [parentControl]="form.get('regionId')"
            [controlName]="form.get('districtId')"
            label="COMPANY.TABLE_HEADERS.REGION"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-4">
          <app-cab-autocomplete
            [firstLoad]="true"
            [_defaultService]="_ownerShipTypeService"
            [controlName]="form.get('ownershipTypeId')"
            label="COMPANY.TABLE_HEADERS.TYPE_COMPANY"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-4">
          <app-cab-input
            [controlName]="form.get('directorFio')"
            label="COMPANY.TABLE_HEADERS.DIRECTOR_FIO"
          />
        </div>
        @if (!isEdit()) {
          <div class="col-12 col-sm-12 col-md-4">
            <app-cab-input
              type="number"
              [controlName]="form.get('contractNo')"
              label="COMPANY.TABLE_HEADERS.CONTRACT_NUMBER"
            />
          </div>

          <div class="col-12 col-sm-12 col-md-4">
            <app-cab-file-input
              [controlName]="form.get('contractFile')"
              label="COMPANY.TABLE_HEADERS.CONTRACT_FILE"
              [bucketName]="EBucketNames.COMPANY_CONTRACTS"
            />
          </div>

          <div class="col-12 col-sm-12 col-md-4">
            <app-cab-calendar
              [controlName]="form.get('contractStartDate')"
              dateType="string"
              label="COMPANY.TABLE_HEADERS.CONTRACT_START_DATE"
            />
          </div>

          <div class="col-12 col-sm-12 col-md-4">
            <app-cab-calendar
              [controlName]="form.get('contractEndDate')"
              [minDate]="this.minDate"
              dateType="string"
              label="COMPANY.TABLE_HEADERS.CONTRACT_END_DATE"
            />
          </div>
        }
        <div class="col-12 col-sm-12 col-md-4">
          <app-cab-input
            [controlName]="form.get('bankName')"
            label="COMPANY.TABLE_HEADERS.BANK_NAME"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-4">
          <app-cab-input
            type="number"
            [controlName]="form.get('bankMfo')"
            [readonly]="true"
            label="COMPANY.TABLE_HEADERS.TURNOVER"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-4">
          <app-cab-input
            [controlName]="form.get('inn')"
            [readonly]="true"
            type="number"
            label="COMPANY.TABLE_HEADERS.INN"
          />
        </div>

        <div
          [class]="
            isEdit() ? 'col-12 col-sm-12 col-md-4' : 'col-12 col-sm-12 col-md-3'
          "
        >
          <app-cab-input
            [controlName]="form.get('companyAccountNumber')"
            [readonly]="true"
            label="COMPANY.TABLE_HEADERS.COMPANY_ACCOUNT"
            mask="0000 0000 0000 0000 0000"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-3">
          <app-cab-input
            [controlName]="form.get('legalAccountNumber')"
            [readonly]="true"
            label="COMPANY.TABLE_HEADERS.LEGAL_ACCOUNT"
            mask="0000 0000 0000 0000 0000"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-3">
          <app-cab-input
            [controlName]="form.get('transitAccountNumber')"
            [readonly]="true"
            label="COMPANY.TABLE_HEADERS.TRANZIT_ACCOUNT"
            mask="0000 0000 0000 0000 0000"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-3">
          <app-cab-input
            [controlName]="form.get('transitAccMfo')"
            [readonly]="true"
            label="COMPANY.TABLE_HEADERS.TRANSIT_ACC_MFO"
            type="text"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-3">
          <app-cab-select
            [controlName]="form.get('isActive')"
            [options]="statusAction"
            label="EMPLOYEES.TABLE_HEADERS.STATUS"
            [readonly]="!hasPermission()"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-3">
          <app-cab-input
            [controlName]="form.get('phone')"
            label="COMPANY.TABLE_HEADERS.PHONE_NUMBER"
            mask="+000(00) 000-00-00"
            [showMaskTyped]="true"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-3">
          <app-cab-input
            [controlName]="form.get('address')"
            label="COMPANY.TABLE_HEADERS.ADDRESS"
          />
        </div>
        <div class="col-12 col-sm-12 col-md-3">
          <app-cab-input
            [controlName]="form.get('email')"
            label="COMPANY.TABLE_HEADERS.EMAIL"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-3">
          <app-cab-input
            [controlName]="form.get('smsName')"
            label="COMPANY.NAME_FOR_SMS"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-3">
          <app-cab-input-percent
            [controlName]="form.get('dxshPercentage')"
            label="COMPANY.DXSH_PERCENTAGE"
            mask="percent.2"
            [allowNegativeNumbers]="true"
            suffix="%"
          />
        </div>

        <div class="col-12">
          <app-cab-textarea
            [controlName]="form.get('description')"
            label="COMPANY.TABLE_HEADERS.COMMENT"
          />
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-sm-end gap-2 mt-5 modal-footer">
      <app-cab-button
        label="GEOGRAPHY.MODAL_BUTTON.ADD_BUTTON"
        type="submit"
        size="sm"
        styleType="success"
        [isPending]="isPending()"
        [disabled]="form.invalid || isPending()"
      />
      <app-cab-button
        (btnClick)="onCancel()"
        styleType="light"
        type="reset"
        size="sm"
        label="GEOGRAPHY.MODAL_BUTTON.CANCEL"
      />
    </div>
  </form>
}
